import React from 'react';

import { SVGComponentProps } from './svg.types';

const SettingsFilledSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M13.3997 6.14679C12.193 6.14679 11.6997 5.29345 12.2997 4.24679C12.6463 3.64012 12.4397 2.86679 11.833 2.52012L10.6797 1.86012C10.153 1.54679 9.47301 1.73345 9.15967 2.26012L9.08634 2.38679C8.48634 3.43345 7.49967 3.43345 6.89301 2.38679L6.81967 2.26012C6.51967 1.73345 5.83967 1.54679 5.31301 1.86012L4.15967 2.52012C3.55301 2.86679 3.34634 3.64679 3.69301 4.25345C4.29967 5.29345 3.80634 6.14679 2.59967 6.14679C1.90634 6.14679 1.33301 6.71345 1.33301 7.41345V8.58679C1.33301 9.28012 1.89967 9.85345 2.59967 9.85345C3.80634 9.85345 4.29967 10.7068 3.69301 11.7535C3.34634 12.3601 3.55301 13.1335 4.15967 13.4801L5.31301 14.1401C5.83967 14.4535 6.51967 14.2668 6.83301 13.7401L6.90634 13.6135C7.50634 12.5668 8.49301 12.5668 9.09967 13.6135L9.17301 13.7401C9.48634 14.2668 10.1663 14.4535 10.693 14.1401L11.8463 13.4801C12.453 13.1335 12.6597 12.3535 12.313 11.7535C11.7063 10.7068 12.1997 9.85345 13.4063 9.85345C14.0997 9.85345 14.673 9.28679 14.673 8.58679V7.41345C14.6663 6.72012 14.0997 6.14679 13.3997 6.14679ZM7.99967 10.1668C6.80634 10.1668 5.83301 9.19345 5.83301 8.00012C5.83301 6.80679 6.80634 5.83345 7.99967 5.83345C9.19301 5.83345 10.1663 6.80679 10.1663 8.00012C10.1663 9.19345 9.19301 10.1668 7.99967 10.1668Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default SettingsFilledSVG;
